import React from 'react';
import { ArrowLeft, Upload, Calendar, Image, Trash2 } from 'lucide-react';

export const AlbumPhotoView = ({ album, uploading, loading, onBack, onUpload, onDeletePhoto, formatDate }) => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <button onClick={onBack} className="flex items-center gap-2 text-gray-400 hover:text-orange-500 transition-colors">
          <ArrowLeft size={20} /> Back to Albums
        </button>
        <label className="bg-orange-500 text-black px-4 py-2 rounded-lg hover:bg-orange-600 flex items-center gap-2 cursor-pointer">
          <Upload size={20} /> Upload Photos
          <input type="file" multiple accept="image/*" onChange={onUpload} className="hidden" />
        </label>
      </div>

      <div className="bg-gray-800 p-6 rounded-lg border border-purple-500/30">
        <h2 className="text-2xl font-bold text-purple-500 mb-2">{album.name}</h2>
        <div className="flex items-center gap-2 text-gray-400 text-sm mb-2">
          <Calendar size={14} />
          <span>{formatDate(album.date)}</span>
        </div>
        {album.description && <p className="text-gray-400">{album.description}</p>}
      </div>

      {uploading && <div className="text-center text-orange-500 py-4">Uploading photos...</div>}

      {loading ? (
        <div className="text-center text-gray-400 py-8">Loading photos...</div>
      ) : !album.photos || album.photos.length === 0 ? (
        <div className="text-center text-gray-400 py-8">
          <Image size={48} className="mx-auto mb-4 opacity-50" />
          <p>No photos in this album yet.</p>
          <p className="text-sm mt-2">Click &quot;Upload Photos&quot; to add some.</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
          {album.photos.map((photo) => (
            <div key={photo.id} className="relative group aspect-square bg-gray-900 rounded-lg overflow-hidden">
              <img src={photo.url} alt={photo.title || 'Photo'} className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                <button onClick={() => onDeletePhoto(photo.id)} className="bg-red-500 text-white p-2 rounded-full hover:bg-red-600 transition-colors">
                  <Trash2 size={18} />
                </button>
              </div>
              {photo.title && (
                <div className="absolute bottom-0 left-0 right-0 bg-black/70 p-2 text-xs text-white truncate">{photo.title}</div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
